export default "__VITE_ASSET__DxKo5gY3__"